import type { UserFuelsConfig } from '../types';

export function createConfig(config: UserFuelsConfig) {
  return config;
}
